import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AXIOS } from '../api'
import { Link } from 'react-router-dom'
import Switch from "react-switch"

import { setFiltrage, setFetch, setLoading } from '../redux/actions'
import { Box, Text, Icons, Icon, PictureItem, Button } from './common/Themes'

const GestionAccessoires = () => {

    const dispatch = useDispatch()
    const { activites, accessoires } = useSelector(state => state.fetch)
    const { filtrage: { aidActive, oidActive }, fetch } = useSelector(state => state.config)

    const [accessoiresFill, setAccessoiresFill] = useState([])
    const [aidFil, setAidFil] = useState()

    useEffect(() => {
        (async () => {
            setAccessoiresFill(accessoires)
            setAidFil(activites[0]?.aid)
        })();
    }, [accessoires, activites])

    useEffect(() => {
        if (aidActive) setAccessoiresFill(accessoires.filter(({ aid }) => aid == aidFil))
        else setAccessoiresFill(accessoires)
    }, [aidFil, aidActive])

    const deleteHandler = async cid => {
        try {
            dispatch(setLoading(true))
            await AXIOS.delete(`/api/v1/accessoires/${cid}`)
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    const gestionItem = (cid, aid, name, article, classement, image) => {
        const activite = activites.filter(activite => activite.aid === aid)[0]
        return (
            <Box key={cid}>
                <input style={{ margin: '0 1rem' }} type="checkbox" defaultChecked={article !== null}></input>
                <PictureItem image={`url(${process.env.REACT_APP_SITE_MARCHAND}${image}), url('/img/default_image.png')`}>&nbsp;</PictureItem>
                <Text color={activite?.color1} style={{ width: '14.4rem' }}>{classement}</Text>
                <Text color={activite?.color1} style={{ marginLeft: '1rem' }}>{name}</Text>
                <Text color={activite?.color1} style={{ marginLeft: '3rem' }}>{activite?.name}</Text>
                <Text color={activite?.color1}></Text>
                <Text color={activite?.color1}></Text>
                <Link to={`/accessoire/${cid}`}>
                    <Icons color={activite?.color1}>
                        <use xlinkHref="/img/sprite.svg#icon-edit"></use>
                    </Icons>
                </Link>
                <Icons onClick={() => deleteHandler(cid)} color={activite?.color1}>
                    <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                </Icons>
            </Box>
        );
    }

    const handleChange = e => setAccessoiresFill(accessoires.filter(({ name }) => name?.toLocaleLowerCase().includes(e.target.value?.toLocaleLowerCase())))

    return (
        <>
            <div className="gestion">
                <div className="gestion__header">
                    <h4 className="gestion__title">Gestion accessoires</h4>
                    <h5 className="gestion__total">{accessoires.length} Total</h5>

                    <div style={{ marginLeft: 'auto', display: 'flex', position: 'relative' }}>
                        <input name="search" onChange={handleChange} className="gestion__input" placeholder="Rechercher" />
                        <Icons color="#B0BAC9" style={{ margin: '1rem', position: 'absolute', right: '1rem' }}>
                            <use xlinkHref="/img/sprite.svg#icon-search"></use>
                        </Icons>
                    </div>

                </div>
                <div className="gestion__container">
                    <h4 className="gestion__subTitle">Filtrage des accessoires</h4>
                    <div className="gestion__filtrage">
                        <div className="gestion__filtrageWrapper">
                            <Switch checked={aidActive} onColor="#45B755" offColor="#ED292D" onChange={() => dispatch(setFiltrage({ aidActive: !aidActive, oidActive }))} />
                            <div className="form__inputbox gestion__inputbox">
                                <label htmlFor="birthday" className="form__label">Activité</label>
                                <select name="aid" onChange={e => setAidFil(e.target.value)} className="form__input" style={{ padding: '0 1rem' }}>
                                    {activites.map(({ aid, name }) => <option className="form__dropdown" key={aid} value={aid}>{name}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
                <Button to='/accessoire' color={'#FF5C00'} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Icons color={'#fff'} style={{ margin: '0 1rem 0 0', width: '16px' }}>
                        <use xlinkHref="/img/sprite.svg#icon-plus"></use>
                    </Icons>
                    Nouveau
                </Button>
                <div className="gestion__content">
                    <div className="gestion__listheader">
                        <div className="gestion__headerItem" style={{ width: '14.4rem' }}></div>
                        <div className="gestion__headerItem" style={{ width: '14.4rem' }}>Classement</div>
                        <div className="gestion__headerItem">Nom</div>
                        <div className="gestion__headerItem">Activité</div>
                    </div>
                    <div className="gestion__list">
                        {accessoiresFill.map(({ cid, aid, name, article, classement, image }) => gestionItem(cid, aid, name, article, classement, image))}
                    </div>
                    <Link to='/accessoire' style={{ alignSelf: 'center' }}>
                        <Icon color='#FF5C00' style={{ marginBottom: '0' }}>
                            <use xlinkHref="/img/sprite.svg#icon-plus-alt"></use>
                        </Icon>
                    </Link>
                </div>
            </div>
        </>
    );
}

export default GestionAccessoires